import React from 'react';
import PropTypes from 'prop-types';

import {Box} from 'views/components';

import ContentView from './ContentView';

// The legacy Content switched between view and edit modes. This copy only views.
const Content = (props) => {
  const careviewItem = props.careviewItem;

  return (
    <Box>
      <ContentView
        careviewItem={careviewItem}
      />
    </Box>
  );
};

Content.propTypes = {
  careviewItem: PropTypes.object.isRequired,
};
export default React.memo(Content);
